import type {ApiOptions, ApiPostOptions} from 'src/utils/redux-api';

import {fetching, key} from 'src/utils/redux';
import * as reduxApi from 'src/utils/redux-api';
import {thunkify as flow} from 'src/utils/thunks';
import {TALENT_POOL_LIST_SUGGESTION_PAGE_SIZE} from 'src/constants/talent-pools';

import type {TalentPoolListSuggestion} from 'src/types/talent-pools';

import type {Dispatch, ThunkAction} from 'src/reducers';


const API_PATH: ApiOptions = {
  apiPath: '/trmapi/api/v1/',
};

const API_POST_PATH: ApiPostOptions = {
  apiPath: '/trmapi/api/v1/',
};

export const TALENT_POOL_LIST_SUGGESTION =
  'talent-pools/talent-pool-list-suggestion';
export const TALENT_POOL_LIST_SUGGESTION_ERROR =
  'talent-pools/talent-pool-list-suggestion-error';

type TalentPoolListSuggestionAction = {
  type: typeof TALENT_POOL_LIST_SUGGESTION;
  payload: TalentPoolListSuggestion;
};

type TalentPoolListSuggestionErrorAction = {
  type: typeof TALENT_POOL_LIST_SUGGESTION_ERROR;
  payload: Error;
};

export type TalentPoolListSuggestionActions =
  | TalentPoolListSuggestionAction
  | TalentPoolListSuggestionErrorAction;

export const getTalentPoolListSuggestion: (
  page: number,
  page_size: number,
) => ThunkAction<void> = flow(
  key(
    (page: number, page_size: number) =>
      `talent-pool-folders/suggested?page=${page}&page_size=${page_size}`,
  ),
  fetching(),
)((page: number, page_size: number) => (dispatch: Dispatch) => {
  return dispatch(
    reduxApi.get<TalentPoolListSuggestion>(
      `talent-pool-folders/suggested?page=${page}&page_size=${page_size}`,
      {},
      API_PATH,
    ),
  )
    .then((response: TalentPoolListSuggestion) => {
      dispatch({
        type: TALENT_POOL_LIST_SUGGESTION,
        payload: response,
      });
    })
    .catch((error: Error) => {
      dispatch({
        type: TALENT_POOL_LIST_SUGGESTION_ERROR,
        payload: error,
      });
    });
});

export const discardTalentPoolSuggestion: (
  talentPoolId: number,
) => ThunkAction<void> = flow(
  key(
    (talentPoolId: number) =>
      `talent-pool-folders/${talentPoolId}/discard-suggestion`,
  ),
  fetching(),
)((talentPoolId: number) => (dispatch: Dispatch) => {
  return dispatch(
    reduxApi.post(
      `talent-pool-folders/${talentPoolId}/discard-suggestion`,
      {},
      {},
      API_POST_PATH,
    ),
  ).then((response) => {
    if (response) {
      dispatch(
        getTalentPoolListSuggestion(0, TALENT_POOL_LIST_SUGGESTION_PAGE_SIZE),
      );
    }
  });
});
